import MenuHorizontalIcon from '@assets/icons/menu-horizontal.svg';
import React, { useRef, useState } from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { Button } from '@/components/button';
import { List } from '@/components/list';
import { ListOption } from '@/components/list-item';
import { StyleSheet, View } from 'react-native';
import { SvgProps } from 'react-native-svg';
import { ThemedSVGProps } from '@/styles';

export type OrderInvoiceActionListOption = ListOption<{
  Icon: React.ComponentType<SvgProps>;
  iconProps?: ThemedSVGProps;
  onPress: () => void | Promise<void>;
  stackedSheet: boolean;
}>;

interface Props {
  actions: OrderInvoiceActionListOption[];
}

export enum OrderInvoiceAction {
  CREDIT_REQUEST = 'CREDIT_REQUEST',
  DUPLICATE_ORDER_TO = 'DUPLICATE_ORDER_TO',
  PAY_INVOICE = 'PAY_INVOICE',
  PRINT_ORDER_LABEL = 'PRINT_ORDER_LABEL',
  REORDER_ALL_ITEMS = 'REORDER_ALL_ITEMS',
  REVIEW_ORDER = 'REVIEW_ORDER',
  VIEW_INVOICE_PDF = 'VIEW_INVOICE_PDF',
  VIEW_ORIGINAL_INBOUND = 'VIEW_ORIGINAL_INBOUND',
}

export const OrderInvoiceActions: React.FC<Props> = ({ actions }) => {
  const [showActions, setShowActions] = useState(false);
  const buttonRef = useRef<View>(null);

  return (
    <>
      <Button
        Icon={MenuHorizontalIcon}
        onPress={() => setShowActions(true)}
        ref={buttonRef}
        size="small"
        style={styles.button}
        testID="order-details-actions-button"
        trackingData={null}
        type="tertiary"
      />
      {showActions ? (
        <BaseActionSheet
          contentStyle={styles.actionSheetContent}
          isVisible
          onClose={() => setShowActions(false)}
          popoverStyle={(_, targetPosition) => ({
            right: targetPosition.width - 18,
            top: targetPosition.height + targetPosition.y,
          })}
          popoverTarget={buttonRef.current}
        >
          <List<OrderInvoiceActionListOption>
            data={actions}
            onSelect={async (item) => {
              if (item.metadata?.stackedSheet) {
                setShowActions(false);
                await item.metadata?.onPress();
              } else {
                await item.metadata?.onPress();
                setShowActions(false);
              }
            }}
            renderLeftComponent={(item) => {
              const { Icon, iconProps } = item.metadata!;
              return <Icon height={24} width={24} {...iconProps} />;
            }}
          />
        </BaseActionSheet>
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  actionSheetContent: {
    paddingHorizontal: 0,
  },
  button: {
    marginRight: -12,
  },
});
